function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aee6a912-954e-4c0d-8bda-fdc12d110dae",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "b970cacb-c03c-4f42-aa4f-1125edeb7a05",
    "data-name": "Wave-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a77c6186-2e5a-4cdf-9a38-bb7576035260",
    "data-name": "Rectangle",
    d: "M1366,48C644,48,644-19.35544,0,5.51V48Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  })));
}

export default SvgWave12;